import cubejs from "@cubejs-client/core"
import _ from "lodash"
import {CubejsApi, LoadResponse} from "@/cube/cubejs"
import {Dimension, Measure, Metric} from "@/cube"

// initialize cubejs instance with API Token and API URL

const apiUrl = "/cubejs-api/v1"

let metadata: any

async function getMetadata() {
  if (metadata == null) {
    metadata = cubejsApi.meta()
  }

  return metadata
}

export async function getDimensions(): Promise<Array<any>> {
  return _.flatMap((await getMetadata()).cubes, cube => cube.dimensions)
}

export async function getMeasures(): Promise<Array<any>> {
  return _.flatMap((await getMetadata()).cubes, cube => cube.measures)
}

// TODO fix types
export type QueryResult = LoadResponse<any, any, any, any, any>

export type QueryData = Array<
  {[key in (Dimension & string) | (Metric & string)]?: any}
>

export const cubejsApi: CubejsApi<Measure, Dimension> = <any>cubejs({apiUrl})
